<template>
  <div class="countdownTimer" v-if="enableCoutdown">
    <div class="countdownTimer__col countdownTimer__hours h5">
      <span>{{ countdownTimer.hours }}</span>
      <span>Hours</span>
    </div>
    <div class="countdownTimer__col countdownTimer__min h5">
      <span>{{ countdownTimer.minutes }}</span>
      <span>Min</span>
    </div>
    <div class="countdownTimer__col countdownTimer__sec h5">
      <span>{{ countdownTimer.seconds }}</span>
      <span>Sec</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CountDownTimer',
  props: {
    endDate: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      timer: null,
      countdownTimer: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      }
    }
  },
  created() {
    this.showCountDownTimer();
  },
  computed: {
    enableCoutdown() {
      if (isNaN(this.countdownTimer.hours) && isNaN(this.countdownTimer.minutes) && isNaN(this.countdownTimer.seconds)) {
        return false;
      } else if (this.countdownTimer.hours <= 0 && this.countdownTimer.minutes <= 0 && this.countdownTimer.seconds <= 0) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    getEastTimeOffset : function() {
      const jan = new Date(new Date().getFullYear(),0, 1);
      const jul = new Date(new Date().getFullYear(),6, 1);
      let diff = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset())
      let today = new Date();
      return today.getTimezoneOffset() < diff ? -4 : -5;

  },
    showCountDownTimer: function () {
      if (this.endDate != "") {

        var endDate = new Date(this.endDate.replaceAll('-', '/'));//safari fix
        var time = this;
        var offset = this.getEastTimeOffset();

        this.timer= setInterval(function () {
          let todayDate = new Date();
          let localTime = todayDate.getTime();
          let localOffset = todayDate.getTimezoneOffset() * 60000;
          let utc = localTime + localOffset;
          let now = new Date(utc + (3600000 * offset));
          let timeDiff = endDate - now;

          time.countdownTimer.hours = Math.floor((timeDiff / (1000 * 60 * 60)));
          time.countdownTimer.minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
          time.countdownTimer.seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

          if (time.countdownTimer.hours <= 0 && time.countdownTimer.minutes <= 0 && time.countdownTimer.seconds <= 0) {
              time.countdownTimer.hours = 0;
              time.countdownTimer.minutes = 0;
              time.countdownTimer.seconds = 0;
            clearInterval(time.timer);


      }

        }, 1000);
      }
    }
  }
}

</script>

<style scoped lang="scss">
.countdownTimer {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;

  &__col {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    // border: 1px solid #000;
    background: rgba(0,0,0,.7);
    color: #fff;
    opacity: 0.6;
    border-radius: 10px;
    padding: 5px;
    /* padding for the text */
    @include desktop-up {
     min-width: 120px;
    }
    @include mobile-only {
      flex-grow: 1;
      flex-basis: 0;
    }
    @include tablet-only {
      flex-grow: 1;
      flex-basis: 0;
    }
    /* minimum width for the column */
    &:first-child {
      margin-left: 5vw;
    }
  }

}
</style>
